import { render, staticRenderFns } from "./IbCollapseToggle.vue?vue&type=template&id=189c0413&scoped=true"
import script from "./IbCollapseToggle.vue?vue&type=script&lang=js"
export * from "./IbCollapseToggle.vue?vue&type=script&lang=js"
import style0 from "./IbCollapseToggle.vue?vue&type=style&index=0&id=189c0413&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189c0413",
  null
  
)

export default component.exports